import { z } from "zod";
import { adminOperatorIdSchema } from "./admin-operations-core.js";
import { customerOperationsOpaqueIdSchema } from "./customer-operations-core.js";
import { supportTicketIdempotencyKeySchema } from "./customer-operations-support.js";
import { adminSupportWorkspaceSchemaVersionSchema } from "./admin-operations-support-workspace.js";
/** Preserved approved Support wording; insert/edit in an ordinary reply, never send separately. */
export const SUPPORT_SIGN_IN_GUIDANCE = {
    id: "PASSWORDLESS_EMAIL_V1",
    path: "/sign-in",
    message: "To sign in, use the email address for your account and request a fresh sign-in email or code. Check your spam folder and use only the newest email. We’ll never ask you to share your sign-in code. If it still doesn’t arrive, reply here and we’ll keep helping.",
};
export const adminSupportDraftTextSchema = z.string().trim().max(4_000);
const base = {
    schemaVersion: adminSupportWorkspaceSchemaVersionSchema,
    ticketId: customerOperationsOpaqueIdSchema,
};
export const adminSupportDraftSaveCommandSchema = z
    .object({
    ...base,
    action: z.literal("SAVE_REPLY_DRAFT"),
    commandId: supportTicketIdempotencyKeySchema,
    expectedDraftVersion: z.number().int().nonnegative(),
    message: adminSupportDraftTextSchema,
})
    .strict();
export const adminSupportDraftReadCommandSchema = z
    .object({
    ...base,
    view: z.literal("REPLY_DRAFT"),
})
    .strict();
export const adminSupportDraftSaveResponseSchema = z
    .object({
    data: z
        .object({
        ...base,
        commandId: supportTicketIdempotencyKeySchema,
        authorId: adminOperatorIdSchema,
        previousVersion: z.number().int().nonnegative(),
        version: z.number().int().positive(),
        savedAt: z.string().datetime(),
    })
        .strict()
        .refine((value) => value.version === value.previousVersion + 1),
})
    .strict();
export const adminSupportDraftReadResponseSchema = z
    .object({
    data: z
        .object({
        ...base,
        authorId: adminOperatorIdSchema,
        draft: z
            .object({
            version: z.number().int().nonnegative(),
            message: adminSupportDraftTextSchema,
            updatedAt: z.string().datetime().optional(),
        })
            .strict(),
        signInGuidance: z
            .object({
            id: z.literal(SUPPORT_SIGN_IN_GUIDANCE.id),
            path: z.literal(SUPPORT_SIGN_IN_GUIDANCE.path),
            message: z.literal(SUPPORT_SIGN_IN_GUIDANCE.message),
        })
            .strict(),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=admin-operations-support-draft.js.map